module.exports = __webpack_public_path__ + "static/media/button-app-store@2x.a4beae20.png";